import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import api from '../../Utils/Axios';

const AdminPayments = () => {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        const res = await api.get('/api/admin/payments');
        setPayments(res.data.payments || []);
      } catch (err) {
        toast.error(err?.response?.data?.message || 'Failed to load payments');
      } finally {
        setLoading(false);
      }
    };

    load();
  }, []);

  return (
    <div className="col-lg-12">
      <div className="table-wrapper2">
        <div className="title-and-btn">
          <div className="title">
            <h4>Payments & Subscriptions</h4>
          </div>
        </div>
        {loading ? (
          <p>Loading payments...</p>
        ) : (
          <table className="eg-table table job-list-table mb-0">
            <thead>
              <tr>
                <th>Payer</th>
                <th>Purpose</th>
                <th>Amount</th>
                <th>Status</th>
                <th>Currency</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {payments.length === 0 ? (
                <tr>
                  <td colSpan="6">No payments found.</td>
                </tr>
              ) : (
                payments.map((p) => (
                  <tr key={p._id}>
                    <td>
                      {p.hospitalId?.name || p.userId?.firstName || 'Unknown'}
                      <div style={{ fontSize: 12, opacity: 0.7 }}>
                        {p.hospitalId?.email || p.userId?.email || '-'}
                      </div>
                    </td>
                    <td>{p.purpose || 'general'}</td>
                    <td>${p.amount || 0}</td>
                    <td>{p.status}</td>
                    <td>{String(p.currency || 'usd').toUpperCase()}</td>
                    <td>{new Date(p.createdAt).toLocaleString()}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default AdminPayments;
